import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { Hospitalisation, Patient, Intervention } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";

export default function InterventionCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: Intervention;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: Intervention) => void;
}) {
  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={
        <div className="c1 capitalize gap5">
          <div>{item.reference?.name}</div>
        </div>
      }
      subTitle={<div>{getUserShortName(item?.creator) || ""}</div>}
      onEdit={async () => {
        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("interventions", "addOne", {
              intervention: newItem,
            });
            onChange?.(newItem);
          },
        });
      }}
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("interventions", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    ></Card>
  );
}
